import { formatISO } from 'date-fns'
import { Draft } from 'immer'
import { v4 as uuidV4 } from 'uuid'
import { PlanTimescale, User } from '@opallabs/concepts'
import { PlansCollectionResponse } from '../types'

type NewResourceAttributes = {
  creator: User
  defaultTimescale?: PlanTimescale
  endDate: string
  startDate: string
  title: string
}

const createResource = ({
  creator,
  defaultTimescale,
  endDate,
  title,
  startDate,
}: NewResourceAttributes) => ({
  id: 'temp-' + uuidV4(),
  description: '',
  title: title,
  kind: 'plan' as const,
  end_at: formatISO(endDate),
  start_at: formatISO(startDate),
  updated_at: formatISO(new Date()),
  default_timescale: defaultTimescale ?? ('month' as const),
  owner: {
    id: creator.uuid,
    full_name: creator.name,
    avatar_url: creator.asset?.url || null,
    legacy_id: creator.legacyId,
  },
  parent_block: {
    id: 'temp-' + uuidV4(),
    description: '',
    title: title,
    duration: null,
    end_at: formatISO(endDate),
    start_at: formatISO(startDate),
    color: null,
    owner: {
      id: creator.uuid,
      full_name: creator.name,
      avatar_url: creator.asset?.url || null,
      legacy_id: creator.legacyId,
    },
    plan: null,
    created_at: new Date().toISOString(),
  },
  colors: [],
  categories: [],
  key_dates: [],
  valid_start_at: '',
  valid_end_at: '',
  supportive_category_id: '',
  created_at: new Date().toISOString(),
})

export const insertNew = (attributes: NewResourceAttributes) => {
  return (draftResponse: Draft<PlansCollectionResponse>) => {
    const newPlan = createResource(attributes)

    draftResponse.data.push(newPlan)

    return draftResponse
  }
}
